import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_API_PATH;

export const getJobById = async (interviewId) => {
    const res = await axios.get(`${baseUrl}/ebench/get_job_by_jobId?jobId=${interviewId}`);
    return res.data?.data;
};

export const postLaterApi = async (formData) => {
    try {
        const response = await axios.post(`${baseUrl}/ebench/postlater_job`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        toast.success('Job posted successfully!');
        return response;
    } catch (error) {
        toast.error(error.response.data.status.message);
        console.error('postLaterApi error:', error);
        throw error; // re-throw if you want to handle it further where it's called
    }
};